import { LeadPageType } from 'enums/leadPageTypes';
import { leadLazyLoad } from 'utils/loadable';

export const SkillsChecklistPage = leadLazyLoad(
  () => import('./SkillsChecklist'),
  module => module.SkillsChecklist,
  { fallback: null, type: LeadPageType.SKILLS_CHECKLIST },
);
